import { AntColorPicker } from './styles';

export default AntColorPicker;
